import { Button, Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../shared/state/root-reducer';
import { useMemo } from 'react';

export const PaymentHubButton = () => {
  const location = useLocation();
  const selectedEncounter = useSelector((state: RootState) => state.patientContext?.selectedEncounter);
  const selectedPatient = useSelector((state: RootState) => state.patientContext?.selectedPatient);

  const to = useMemo(() => {
    if (selectedEncounter?.patientId && selectedEncounter?.patientEncounterId) {
      return `/hub/patient/${selectedEncounter.patientId}/ioc/${selectedEncounter.patientEncounterId}`;
    }
    if (selectedPatient?.patientId) {
      return `/hub/patient/${selectedPatient.patientId}`;
    }
    const match = location.pathname.match(/^\/specialist\/dashboard\/(\d+)(?:\/|$)/);
    if (match) {
      return `/hub/patient/${match[1]}`;
    }
    return '/hub';
  }, [location.pathname, selectedEncounter?.patientId, selectedEncounter?.patientEncounterId, selectedPatient?.patientId]);

  return (
    <Box sx={{
      position: 'absolute',
      right: '2rem',
      top: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      zIndex: 2,
      '@media (min-width: 960px)': { right: '7rem' }
    }}>
      <Button
        component={Link}
        to={to}
        variant="contained"
        test-id="payment-hub-button"
        sx={{
          backgroundColor: '#297ec1',
          color: 'white',
          fontSize: '1.6rem',
          fontWeight: 600,
          textTransform: 'none',
          fontFamily: 'Inter, "Helvetica Neue", sans-serif',
          '&:hover': {
            backgroundColor: '#1f5f9a',
          },
        }}
      >
        Payment Hub
      </Button>
    </Box>
  );
};
